<!-- 单项选择题 -->
<template>
    <div class="topic_choice">
        <div class="flex topic_select">
            <!-- <div class="topic_type">单选题</div> -->
            <div class="topic_content scroll_x mar_left_10 flex-1">
                <div class="flex">
                    <div class="mt-8">（{{ questionNumber }}）、</div>
                    <div class="topic_title" v-html="$Tools.handlerImg(topicInfo?.stem)" v-mathml></div>
                </div>
                <div>
                        <div v-for="(item, index) in topicInfo?.options" :key="index">
                                <div class="flex FlexStart" style="line-height: 34px;">
                                    <div>{{ item.label }} .</div>
                                    <div v-html="$Tools.handlerImg(item.content)" v-mathml></div>
                                </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "GjkcH5Choice",
    props: {
        questionInfo: {},
        disabled:{},
        questionNumber:{}
    },
    computed: {
        ...mapState({
            // testExamTime: (state) => state.exam.testExamTime,
        }),
    },

    data() {
        return {
            topicInfo: {},
        };
    },
    watch: {
        questionInfo: {
            handler(val) {
                if (val) {
                    this.topicInfo = this.questionInfo;
                    // 判断是否回答过
                    // if (this.topicInfo.courseExamRecordId) {
                    //     this.topicInfo.doAnswer = this.topicInfo.questionContext.doAnswer;
                    // }
                }
            },
            deep: true,
            immediate: true
        }
    },

    mounted() { },

    methods: {
        changeAnswer(value) {
            this.topicInfo.doAnswer = value;
            if (value == this.topicInfo?.answer) {
                this.topicInfo.isCorrect = 1;
            } else {
                this.topicInfo.isCorrect = 2;
            }
            this.topicInfo.questionScore = (this.topicInfo.isCorrect == 1 ? this.topicInfo.score : 0); // 得分
            // this.topicInfo.questionContext.doAnswer = this.topicInfo.doAnswer;   // 保存答案
            // this.topicInfo.questionContext.isFinish = true;   // 是否已完成
            this.$emit('answerQuestion', this.topicInfo);
        }
    },
};
</script>

<style lang="scss" scoped>
@use "@/assets/style/question.scss" as *;
.topic_select {
    font-size: 12px;
    .topic_type {
        // margin-top: 1rem;
        width: 45px;
        height: 21px;
        background: rgba(0, 199, 88, 0.2);
        border-radius: 4px;
        border: 1px solid #00c758;
        line-height: 21px;
        text-align: center;
        font-size: 12px;
        color: #00c758;
    }

    .topic_content {

        // overflow-x: auto;
        .topic_title {
            // font-size: 16px;
            color: #242324;
            font-weight: 600;
        }
    }
}

.bottom_box {
    position: absolute;
    left: calc(50% - 60px);
    bottom: 40px;
    text-align: center;

    .btn_view {
        width: 120px;
        height: 42px;
        background: linear-gradient(90deg, #00D5C2, #00D498);
        border-radius: 21px;
        text-align: center;
        line-height: 42px;
        color: #fff;
        font-size: 18px;
    }

    .view_analysis {
        color: #13D6AA;
    }
}

.topic_answer {
    width: 100%;
    font-size: 12px;
    // height: 222px;
    // background: rgba(19, 214, 170, 0.05);
    border-radius: 10px;
    padding: 20px;
    color: #666666;
    box-sizing: border-box;

    .answer_top {
        .correct_value_answer {
            color: RGBA(0, 199, 88, 1);
        }

        .error_value_answer {
            color: RGBA(255, 49, 49, 1);
        }

        .btn_ask {
            width: 64px;
            height: 28px;
            background: linear-gradient(90deg, #00d5c2, #00d498);
            border-radius: 14px;
            line-height: 28px;
            text-align: center;
            color: #fff;
        }
    }

    .question_analyze {
        color: #333333;
        font-weight: 600;
    }
}
</style>